var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartBox"},[_c('div',{ref:"myChart",staticClass:"myChart",style:({ width: _vm.width, height: _vm.height })}),(_vm.legIsShow)?_c('ul',{staticClass:"legth",style:({ top: _vm.legTop, left: _vm.legLeft })},_vm._l((_vm.legthWZ),function(item,i){return _c('li',{key:i},[_c('h3',{style:({
          backgroundColor: _vm.legthColor[i],
          width: _vm.legendwidth,
          height: _vm.legendheight,
          marginTop: _vm.margintop
        })}),_c('span',[_vm._v(_vm._s(item))])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }